import { getEventTargetMouseOffset } from '@collector/shared-ui'
import {
  COORDINATE_COUNT,
  getCoordinate,
  getMouseEventCoordinates,
  validateCoordinate,
  type Coordinates,
} from '@collector/shared-ui-domain'

function getCoordinateZone(
  coordinate: number,
  coordinateCount: number,
  zoneCount: number,
): number {
  return Math.ceil((coordinate / coordinateCount) * zoneCount)
}

function getCoordinateInZone(
  coordinate: number,
  coordinateCount: number,
  zonesCount: number,
  offset: number,
  dimensionLength: number,
): number {
  const coordinateZone = getCoordinateZone(
    coordinate,
    coordinateCount,
    zonesCount,
  )

  const coordinateClickedZone = getCoordinate(
    offset,
    dimensionLength,
    zonesCount,
  )

  // If the clicked zone does not match the expected coordinate zone,
  // adjust the coordinate by subtracting 1. This ensures that the
  // coordinate remains within the bounds of the correct zone.
  if (coordinateClickedZone !== coordinateZone) {
    return coordinate - 1
  }

  return coordinate
}

export function getCoordinateZoneIndex(
  coordinate: number,
  zoneCount: number,
): number {
  validateCoordinate(coordinate)

  return getCoordinateZone(coordinate, COORDINATE_COUNT, zoneCount) - 1
}

export function getMouseEventCoordinatesInZone(
  event: MouseEvent,
  targetElement: HTMLElement,
  zonesCount: number,
): Coordinates {
  const { eventOffsetX, eventOffsetY } = getEventTargetMouseOffset(
    event,
    targetElement,
  )

  const targetRectangle = targetElement.getBoundingClientRect()
  const { x, y } = getMouseEventCoordinates(event, targetElement)

  const xInZone = getCoordinateInZone(
    x,
    COORDINATE_COUNT,
    zonesCount,
    eventOffsetX,
    targetRectangle.width,
  )

  const yInZone = getCoordinateInZone(
    y,
    COORDINATE_COUNT,
    zonesCount,
    eventOffsetY,
    targetRectangle.height,
  )

  return {
    x: xInZone,
    y: yInZone,
  }
}
